import React from 'react';
import { useMetaPixelPageView } from '../hooks/useMetaPixel';
import { HeroSection } from './HeroSection';
import { ProblemSection } from './ProblemSection';
import { FailedAttemptsSection } from './FailedAttemptsSection';
import { MechanismSection } from './MechanismSection';
import { WhatYouGetSection } from './WhatYouGetSection';
import { AudienceSection } from './AudienceSection';
import { HowItWorksSection } from './HowItWorksSection';
import { ProofSection } from './ProofSection';
import { FAQSection } from './FAQSection';
import { OfferSection } from './OfferSection';
import { Footer } from './Footer';
export function SalesPage() {
  useMetaPixelPageView();
  return <main className="flex flex-col w-full" data-id="element-204">
      <HeroSection data-id="element-205" />
      <ProblemSection data-id="element-206" />
      <FailedAttemptsSection data-id="element-207" />
      <MechanismSection data-id="element-208" />
      <WhatYouGetSection data-id="element-209" />
      <AudienceSection data-id="element-210" />
      <HowItWorksSection data-id="element-211" />
      <ProofSection data-id="element-212" />
      <FAQSection data-id="element-213" />
      <OfferSection data-id="element-214" />
      <Footer data-id="element-215" />
    </main>;
}